import { UserInfo, CourseModel } from '@descomplica/dex-models';

export interface UserState {
  user?: UserInfo;
  token?: string;
  role?: string;
  isStaffMember?: boolean;
  users: { [key: string]: UserInfo };
  shouldDisplaySocialMetaverse?: boolean; // It is the feature-flag for the social metaverse
  canViewTermsOfUse?: boolean;
  currentCourse?: CourseModel;
  shouldShowEqualWebWidget?: boolean;
  shouldDisplayPublicVideoNotes?: boolean;
  showDueDateWarning?: boolean;
  gradeActivitiesViaAi?: boolean;
  verifyMicrocertificatesEligibilityAutomatically?: boolean;
  shouldShowGradeWorthyActivities?: boolean;
  shouldShowClassroomsUgOnboarding?: boolean;
  shouldShowStudyCalendarGoogleIntegration?: boolean;
  shouldShowOnboardingV2?: boolean;
  shouldShowTicketCentral?: boolean;
  shouldShowChatBot?: boolean;
}

const state: UserState = {
  user: undefined,
  token: undefined,
  role: undefined,
  isStaffMember: false,
  users: {},
  shouldDisplaySocialMetaverse: false,
  canViewTermsOfUse: false,
  currentCourse: undefined,
  shouldDisplayPublicVideoNotes: false,
  showDueDateWarning: false,
  gradeActivitiesViaAi: false,
  verifyMicrocertificatesEligibilityAutomatically: false,
  shouldShowGradeWorthyActivities: false,
  shouldShowClassroomsUgOnboarding: false,
  shouldShowStudyCalendarGoogleIntegration: false,
  shouldShowOnboardingV2: false,
};

export default state;
